import ModalWizard from '@/pages/publicpages/agent/wizard/Index';

new Vue({
    el: '#wrapper-modal-wizard',
    name: 'WrapperModalWizard',
    components: {
        ModalFindAgent: ModalWizard,
    }
});
